import axios from "axios";

export default {
    name: 'Activate',
    components: {},
    data() {
        return {
            validToken: false,
            statusAnswer: false,
            messageOnError: '',
        }
    },
    created() {
        this.check()
    },
    methods: {
        check() {
            this.$store.dispatch('changeActivate', this.$route.params.token)
                .then(res => {
                    let data = res.data;
                    this.statusAnswer = true
                    if (data.status === 'ok') {
                        this.validToken = true
                        if (res.status === 200) {
                            this.$store.dispatch('logout').then(() => {
                            })
                        }
                    } else {
                        this.validToken = false
                        this.messageOnError = data.message;
                    }
                })
        }
    }
}
